import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DashboardSelector } from "slices/dashboardSlice";
import { fetchDashboardAnalytics } from "slices/dashboardSlice";

function useDashboard() {
  const dispatch = useDispatch();
  const { dashboard } = useSelector(DashboardSelector);
  const { monthWiseSessions, analytics, loader } = dashboard;


  useEffect(() => {
    

    dispatch(fetchDashboardAnalytics())



    return () => {
    };
  }, []);

  return { monthWiseSessions, analytics, loader };
}

export default useDashboard;
